export const getDefaultSelectedTab = (tabs, tabOrder, defaultSelectedTab) => {
  if (defaultSelectedTab) {
    return defaultSelectedTab;
  }
  const passedTabs = Object.keys(tabs);
  const firstTab = tabOrder.find(tab => passedTabs.some(passedTab => passedTab === tab));
  return firstTab || passedTabs[0];
};